import { blog as config } from '~/config/blog';
import fetchJson from '~/utils/Fetch/json';
import { replaceInItem } from '~/utils/Blog/replaceTerms';

export const getPosts = async ({ page, tag, filters, pageLimit }) => {
  const url = config.url('posts/');
  url.searchParams.set('limit', pageLimit ? pageLimit : config.pageLimit);
  url.searchParams.set('include', 'authors,tags');
  url.searchParams.set('page', page || 1);
  if (tag) {
    url.searchParams.set('filter', `tag:${tag}`);
  } else if (filters) {
    url.searchParams.set('filter', filters);
  }
  const result = await fetchJson(url);
  if (result?.data?.posts) {
    result.data.posts = result.data.posts.map(replaceInItem);
  }
  return result;
};

export const getPost = async ({ slug, id }) => {
  let base = 'posts/';
  if (id) {
    base += `${id}/`;
  }

  if (slug) {
    base += `slug/${slug}`;
  }
  const url = config.url(base);
  url.searchParams.set('include', 'authors,tags');
  const result = await fetchJson(url);
  if (result?.data?.posts) {
    result.data.posts = result.data.posts.map(replaceInItem);
  }
  return result;
};

export const getFeaturedPosts = async ({ page }) => {
  const url = config.url('posts/');
  url.searchParams.set('limit', config.featuredLimit);
  url.searchParams.set('filter', 'featured:true');
  url.searchParams.set('page', page || 1);
  const result = await fetchJson(url);
  if (result?.data?.posts) {
    result.data.posts = result.data.posts.map(replaceInItem);
  }
  return result;
};

export const getUrl = (post, group) => {
  if (post.canonical_url) {
    const parsedUrl = new URL(post.canonical_url);
    return parsedUrl.pathname;
  }

  if (group && group === 'real-estate-guides') {
    return `${config.guidesUrl}${post.slug}`;
  }

  const tag = post?.primary_tag;

  if (tag == null) {
    return `${config.baseUrl}all/${post.slug}`;
  }

  return `${config.baseUrl}${tag?.slug}/${post.slug}`;
};

export const getCanonicalUrl = (post, group) => {
  const url = getUrl(post, group);
  return `${process.env.CLIENT_ORIGIN}${url}`;
};

export const getTag = (post) => {
  if (post?.primary_tag) return post?.primary_tag;
  let chosen_tag = null;

  if (!post?.tags) return null;

  post.tags.every((tag) => {
    if (tag.visibility === 'public') {
      chosen_tag = tag;
      return false;
    }
    return true;
  });

  return chosen_tag;
};

export const formatBlogPosts = (posts) => {
  const newPosts = [];
  posts.forEach((post, index) => {
    const tag = getTag(post);
    const url = getUrl(post);
    newPosts[index] = { ...post, tag, url };
  });
  return newPosts;
};
